import 'virtual:svg-icons-register';
import './style.scss';
import 'vite/modulepreload-polyfill';

import './src/globaljs/breakpoints.js';
import './src/globaljs/_toTop.js';
import './src/globaljs/_loadmore.js';
import './src/globaljs/_choices.js';
import './src/globaljs/_smoothscroll.js';
// import './src/globaljs/copyright.js'; // if this should be used globally
//import 'bootstrap/dist/css/bootstrap-grid.min.css';

// only load in DEV mode - we need Gravity Forms classes for styling
if (import.meta.env.DEV) {
  // import('./src/gf-css/gravity-forms-orbital-theme.min.css');
  // import('./src/gf-css/gravity-forms-theme-foundation.min.css');
  // import('./src/gf-css/gravity-forms-theme-framework.min.css');
  // import('./src/gf-css/gravity-forms-theme-reset.min.css');
  // import('./src/gf-css/gravity-forms-common-icons.min.css');
}
// Detects if a component is used on the page and initializes it.
const components = [
  'header',
  //'footer',
  'accordion',
  'advantages',
  'eventlist',
  'form',
  'gallery',
  'heroslider',
  'highlight-list',
  'joblistgallery',
  'newsslider',
  'linklist',
  'logoslider',
  'memberslist',
  'member',
  'numbers',
  'newslist',
  'image',
  'imagetext',
  'pageheader',
  'quote',
  'rc',
  // 'searchoverlay',
  'socialwall',
  'socialsharer',
  'video',
  'anchormenu'
];

/** Toggle this to support both .m-<name> and .<name> during migration */
const SUPPORT_LEGACY_DOT_CLASSES = false;

/** Build the selectors for a given component name */
function selectorsFor(name: string): string[] {
  // Default is .m-<name>
  const selectors = [`.m-${name}`];
  // Optionally also match legacy ".<name>"
  if (SUPPORT_LEGACY_DOT_CLASSES) selectors.push(`.${name}`);
  return selectors;
}

/** Query elements for a component (deduped NodeList-like array) */
function queryComponentEls(name: string): Element[] {
  const selectors = selectorsFor(name);
  const all = selectors
    .flatMap(sel => Array.from(document.querySelectorAll(sel)));
  // Deduplicate while preserving order
  return Array.from(new Set(all));
}

async function init() {
  console.log('[initialized] main.ts');

  // Dynamically import a component only if its elements exist in DOM
  components.forEach(async (name) => {
    const els = queryComponentEls(name);
    if (els.length === 0) return;

    try {
      // Expect default export to be an init function: (elements, options?) => void
      const mod = await import(`./src/components/${name}/${name}.js`);
      const initFn = mod?.default || mod?.init || mod?.[name];
      if (typeof initFn === 'function') {
        // Pass the found elements to the component init
        initFn(els);
      } else {
        console.warn(`[warn] Component "${name}" has no callable default export`);
      }
    } catch (e) {
      console.error(e);
      console.error(`[error] error while loading component "${name}"`);
    }
  });
}

// async function init() {
//   //load static components first
//   //await import(`./src/components/paragraphsliderelement/paragraphsliderelement`);

//   // Dynamic importing of the component, if component is detected on the page
//   // The folder name and file name of the component has to be the same as the class name
//   console.log('[initalized] main.ts');
//   components.forEach(async (component: any) => {
//     if (!document.querySelector(component)) return;
//     try {
//       const name = component.replace('.', '');
//       const module = await import(`./src/components/${name}/${name}`);

//       if (module) {
//         module.default(document.querySelectorAll(component));
//       }
//     } catch (e) {
//       console.log(e);
//       console.log(`[error] error while loading ${component}`);
//     }
//   });
// }

init();
